/**
 * Two-letter initials from a display name, falling back to an email local-part.
 */
export function getInitials(
  name: string | null | undefined,
  email: string | null | undefined = null,
): string {
  const trimmedName = name?.trim();
  if (trimmedName) {
    const parts = trimmedName.split(/\s+/).filter((part) => part.length > 0);
    if (parts.length >= 2) {
      const first = parts[0];
      const last = parts[parts.length - 1];
      if (first && last && first[0] && last[0]) {
        return `${first[0]}${last[0]}`.toUpperCase();
      }
    }
    const single = parts[0];
    if (single && single.length >= 2) {
      return single.slice(0, 2).toUpperCase();
    }
    if (single?.[0]) {
      return single[0].toUpperCase();
    }
  }

  const trimmedEmail = email?.trim();
  if (trimmedEmail) {
    const local = trimmedEmail.split("@")[0] ?? trimmedEmail;
    if (local.length >= 2) {
      return local.slice(0, 2).toUpperCase();
    }
    if (local[0]) {
      return local[0].toUpperCase();
    }
  }

  return "?";
}
